import * as types from '../types';

const initialState = {
  data: [],
  options: [],
  pagination: {
    rowCount: 0
  },
  paginationSettings: {
    page: 1,
    perPage: 10,
    sort: 'id',
    sortDirection: 'ascending'
  }
};

export const ArticlesReducers = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.FETCH_ARTICLES_SUCCESS:
      return {
        ...state,
        data: action.data,
        pagination: action.pagination,
        paginationSettings: action.paginationSettings
      };

    case types.FETCH_ARTICLES_OPTIONS_SUCCESS:
      return {
        ...state,
        options: action.options
      };

    default:
      return state;
  }
};

export const getArticlesData = state => state.articles.data;
export const getArticlesOptions = state => state.articles.options;
export const getArticlesPagination = state => state.articles.pagination;
export const getArticlesPaginationSettings = state => state.articles.paginationSettings;
